module.exports = __webpack_public_path__ + "static/media/war-flower.06c35515.PNG";